
import React, { useState,useEffect } from "react";
import { policeDatas } from "../../Services/service";
// import PoliceCardStyle from "./PoliceCardStyle";
import { Link } from "react-router-dom";


function PolicePosts() {
const [policeData, setPoliceData] = useState([]);

useEffect(() => {
  loadData();
},[]);

async function loadData() {
  const Pdata= await policeDatas();
  setPoliceData(Pdata.policedata);
}
// console.log("mainPosts",mainPosts)
// console.log("MainPostsData",mainPosts.MainData)
return(
<div className="policeposts">
  <table>
 
      {policeData.map((item, index) => (
        <tr key={index}>
          <Link to={`/Police/${item.id}`}><td>{item.id}</td></Link>
        </tr>
      ))}
  </table>
{/* <div className="row">
      {Array.isArray(policeData.policedata) ?(
        policeData.policedata.map((Item, index) => (
          <div
            key={Item.id || index}
            className="col-xl-4 col-lg-6 col-md-6"
          >
            <div className="binduz-er-main-posts-item">
              <PoliceCardStyle
                datas={{
                  id:Item.id,
                  image: Item.image,
                  place: Item.place,
                  name: Item.name,
                  post: Item.post,
                  phoneno: Item.phoneno,
                }}
              >
              </PoliceCardStyle>
            </div>
          </div>
        ))):(
          <h2>No Data</h2>
        )}
    </div>  */}
 </div>
 )}

export default PolicePosts;

